import { api } from "../AxiosInstance";

const JobHistoryService = {
  uploadExcelFile: async (file: File) => {
    try {
      const formData = new FormData();
      formData.append("file", file);

      const response = await api.post("/job-history/excel", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      return response;
    } catch (error) {
      console.error("Error uploading excel file:", error);
      throw error;
    }
  },
};

export default JobHistoryService;
